/* @flow */
import * as React from 'react';

import BoxBody from 'components/BoxBody';
import Dialog from 'components/Dialog';
import TitleHeader from 'components/TitleHeader';
import QuickPromotion from 'entities/QuickPromotion';
import Input from 'components/Input';
import Button from 'components/Button';
import Field from 'components/Field';
import invariant from 'invariant';
import { escapeRegExp } from 'lodash';

class SisMergeExistingTeacherModal extends React.Component<
  {
    promotion: QuickPromotion,
    onConfirm: (data: Object) => void,
    onDialogDismiss: () => any,
    onRequestHide: () => any,
  },
  $FlowFixMeState
> {
  state = {
    email: '',
    error: '',
  };
  handleConfirm = () => {
    const emailDomain = this.getEmailDomain();
    const regexp = new RegExp(`.+@${escapeRegExp(emailDomain)}$`);
    if (regexp.test(this.state.email)) {
      this.props.onRequestHide();
      this.props.onConfirm({ teacher_email: this.state.email });
    } else {
      this.setState({ error: `Your email must be an @${emailDomain} address` });
    }
  };

  // $FlowFixMe
  setTeacherEmail = event => {
    const email = event.target.value;
    this.setState({ email });
  };
  getEmailDomain = (): string => {
    const promotionData = this.props.promotion.getData();
    const teacherEmailDomain = promotionData['email_domain'];
    invariant(teacherEmailDomain, 'Teacher email domain must be provided');
    return teacherEmailDomain;
  };
  render() {
    return (
      <Dialog
        eventScreenName="SisMergeExistingTeacherModal"
        className="SisMergeExistingTeacherModal"
        size="small"
        hideOnTransition={false}
        hideOnBlur={false}
        onDialogDismiss={this.props.onDialogDismiss}
        onRequestHide={this.props.onRequestHide}>
        <BoxBody>
          <TitleHeader
            title={this.props.promotion.getHeader()}
            subtext={this.props.promotion.getBody()}
            image={this.props.promotion.getImageUrl()}
          />
          <Field className="SisMergeExistingTeacherModal-field" error={this.state.error}>
            <Input
              name="teacher_email"
              className="SisMergeExistingTeacherModal-input"
              placeholder={`email@${this.getEmailDomain()}`}
              value={this.state.email}
              onChange={this.setTeacherEmail}
            />
          </Field>
          <Button
            full
            data-test="submit-button"
            eventElementName="QuickPromotion-confirm"
            className="SisMergeExistingTeacherModal-submit"
            onClick={this.handleConfirm}>
            Submit
          </Button>
        </BoxBody>
      </Dialog>
    );
  }
}

export default SisMergeExistingTeacherModal;
